module.exports = __webpack_public_path__ + "img/q6.f965601e.gif";